const key = (masterOwnerID: string) =>
  `sweeps:myTeamNumber:${String(masterOwnerID || '').trim()}`;

function normalizeTeam(v: number | null | undefined): number | null {
  if (typeof v === 'number' && Number.isFinite(v)) return Math.round(v);
  return null;
}

/**
 * Team # saved on this browser (explicit user choice). Absent key means "no local override".
 */
export function getMySweepTeamNumber(masterOwnerID: string): number | null {
  const mo = String(masterOwnerID || '').trim();
  if (!mo || typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(key(mo));
    if (raw == null || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? Math.round(n) : null;
  } catch {
    return null;
  }
}

/**
 * Local override if the user saved a team on this device; otherwise the organization's default from their profile.
 */
export function getEffectiveSweepTeamNumber(
  masterOwnerID: string,
  profileDefaultSweepTeam?: number | null
): number | null {
  const mo = String(masterOwnerID || '').trim();
  if (!mo || typeof localStorage === 'undefined') return normalizeTeam(profileDefaultSweepTeam);
  try {
    const raw = localStorage.getItem(key(mo));
    if (raw == null || String(raw).trim() === '') {
      return normalizeTeam(profileDefaultSweepTeam);
    }
    const n = Number(raw);
    return Number.isFinite(n) ? Math.round(n) : normalizeTeam(profileDefaultSweepTeam);
  } catch {
    return normalizeTeam(profileDefaultSweepTeam);
  }
}

/** True if this browser has an explicit saved team (overrides organization default). */
export function hasLocalSweepTeamOverride(masterOwnerID: string): boolean {
  const mo = String(masterOwnerID || '').trim();
  if (!mo || typeof localStorage === 'undefined') return false;
  try {
    const raw = localStorage.getItem(key(mo));
    return raw != null && String(raw).trim() !== '';
  } catch {
    return false;
  }
}

export function setMySweepTeamNumber(masterOwnerID: string, value: number | null): void {
  const mo = String(masterOwnerID || '').trim();
  if (!mo || typeof localStorage === 'undefined') return;
  if (value == null || !Number.isFinite(value)) {
    localStorage.removeItem(key(mo));
    return;
  }
  localStorage.setItem(key(mo), String(Math.round(value)));
}
